import { CdkDragDrop, CdkDragEnd, CdkDragStart } from '@angular/cdk/drag-drop';
import { Component, OnInit, ViewChild, Input, TemplateRef, HostListener } from '@angular/core';
import { FileExplorerService } from '../file-explorer.service';
import { FileItem } from '../models/fileItem';
import { TcmModalService } from '../../../../../modules/tcm-common/services/tcm-modal.service';
import { PermissionsService } from '../../../../../services';
import { SpecialActionAccesses } from '../../../../../models/roles';
import { NullObjectSpecialActions } from '../../../../../modules/tcm-common/security/null-object-special-actions';

@Component({
    selector: 'explorer-view',
    templateUrl: 'explorer.component.html',
    styleUrls: ['explorer.component.scss'],
    standalone: false
})

export class ExplorerComponent implements OnInit {
  @ViewChild('renameModalTemplate', { static: true }) renameModalTemplate!: TemplateRef<unknown>;

  @Input() canEdit: boolean;

  public isDragging: boolean;
  public contextMenuPosition = { x: '0px', y: '0px' };
  public contextMenuItem: FileItem | null = null;
  get specialActionPermissions(): SpecialActionAccesses {
    return this.permissionService.currentPermissions
      ? this.permissionService.currentPermissions.specialActions
      : NullObjectSpecialActions.specialActions;
  }


  constructor(public fileExplorerService: FileExplorerService, private modalSvc: TcmModalService, private permissionService: PermissionsService) { }

  ngOnInit() { }

  public dragStarted(event: CdkDragStart) {
    this.fileExplorerService.hoveredEl = null;
    event.source.element.nativeElement.className += " allow-transform";
  }

  public dragEnded(event: CdkDragEnd) {
    event.source.element.nativeElement.className.replace(" allow-transform", "");
  }

  public drop(event: CdkDragDrop<FileItem[]>) {
    this.fileExplorerService.hoveredEl = this.fileExplorerService.hoveredEl ? this.fileExplorerService.hoveredEl : this.fileExplorerService.hoveredTreeEl;
    if (this.fileExplorerService.hoveredEl
      && this.fileExplorerService.hoveredEl != event.item.data
      && event.item.data.type == "file"
      && this.fileExplorerService.hoveredEl.type == "dir") {

      let item: FileItem = Object.assign({}, event.item.data);
      item.parent = this.fileExplorerService.hoveredEl;
      item.path = this.fileExplorerService.hoveredEl.path;

      this.fileExplorerService.hoveredEl.children.push(item);
      this.fileExplorerService.selected.children.splice(
        this.fileExplorerService.selected.children.indexOf(event.item.data), 1);

      this.fileExplorerService.move(item);
    }
  }

  download(item: FileItem) {
    this.closeContextMenu();
    this.fileExplorerService.download(item);
  }

  delete(item: FileItem) {
    this.closeContextMenu();
    this.fileExplorerService.delete(item)
  }

  openContextMenu(event: MouseEvent, item: FileItem) {
    event.preventDefault();
    event.stopPropagation();

    // Check if the menu should be disabled
    if (!this.canEdit && item.type !== 'file') {
      return;
    }

    this.contextMenuItem = item;
    this.contextMenuPosition = {
      x: event.clientX + 'px',
      y: event.clientY + 'px'
    };
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {    
    if (this.contextMenuItem) {
      this.closeContextMenu();
    }
  }

  closeContextMenu() {
    this.contextMenuItem = null;
  }

  async openRenamePopup(item: FileItem) {
    this.closeContextMenu();

    const isFile = item.type === 'file';

    const data = {
      isFile: isFile,
      nameCurrent: item.name,
      nameNew: item.name
    };

    const renamingConfirmed =
      await this.modalSvc.showActionModalAsync<boolean>(
        isFile ? x => x.Screens.FileExplorer.Fields.RenameFile : x => x.Screens.FileExplorer.Fields.RenameFolder,
        this.renameModalTemplate,
        "sm",
        [
          { title: x => x.Screens.FileExplorer.Actions.Rename, value: true, cssClass: 'complete', requireValidForm: true },
          { title: x => x.Common.SearchActionsAndDetailsActions.Cancel, value: false, cssClass: 'default', isDefault: true }
        ], data);

    if (renamingConfirmed === true && item.name !== data.nameNew) {
      await this.fileExplorerService.renameItemAsync(item, data.nameNew);
    }
  }
}
